import { ASE_OPTIONS } from "@/components/ase/ASEFormConstants";

const YES_NO = ["bidi_retrofit_qualify", "ef_qualified", "existing_fiber_terminal", "existing_inc", "existing_nte", "inc_required", "it_same_floor_as_nte",
  "pipelines_path", "pipelines_vicinity", "proposed_nte_common_space", "railroads_path", "railroads_vicinity",
  "buried_pvc", "buried_innerduct", "need_emt", "need_plenum", "need_core_drill", "need_eyebolt", "need_pullbox", "need_hoffman_box", "need_backboard", "need_outlet", "need_groundbar"];

const LISTS = {
  bidi_timeframe: "timeframe", ef_disqualification_reason: "efDisqualificationReason", ef_needed: "efNeeded", employee_info: "employees",
  equipment_power_config: "powerConfiguration", fiber_terminal_placement: "fiberTerminalPlacement", nte_at_terminal: "nteLocation",
  nte_mounting_wall: "nteMountingWall", nte_placement: "ntePlacement", occupancy_type: "occupancyTypes", owner_or_tenant: "ownerTenant",
  placing_conduit_length: "conduitLength", spf_required: "spfRequired", terminal_mounting_wall: "mountingWall",
};

// Same dropdown choices as the ASE Form (answers are shared)
export const optionsFor = (key) => (YES_NO.includes(key) ? ASE_OPTIONS.yesNo : LISTS[key] ? ASE_OPTIONS[LISTS[key]] : null);
export const DATE_KEYS = ["date_of_site_visit"];
